import APP from 'desktop/epgTypes';

const initialState = {
  allChannelsUrl: '',
  showAllChannelsButton: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case APP.ALL_CHANNELS_BUTTON_INFO:
      return {
        ...state,
        allChannelsUrl: payload.allChannelsUrl,
        showAllChannelsButton: payload.showAllChannelsButton,
      };

    default:
      return state;
  }
};
